import { useQuery } from '@tanstack/react-query'

import { fetchPractitionerLocations } from 'api/fetchers/marketing-capabilities/practitioners/locations/fetchLocations'

export const usePractitionersLocations = () => {
  return useQuery({
    queryKey: ['practitioners-locations'],
    queryFn: ({ signal }: any) => fetchPractitionerLocations()(signal),
    select: (data: any) => data.data,
  })
}
